<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <default-app-bar/>
    <default-view/>
    <dialogs/>
    <loading/>
    <notifications position="bottom right"/>
    <vue-confirm-dialog/>
  </v-app>
</template>

<script>
export default {
  name: "DefaultLayout",
  computed: {
    theme() {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  },
  components: {
    DefaultView: () => import(
        './View'
        ),
    DefaultAppBar: () => import(
        './AppBar'
        ),
    Dialogs: () => import(
        '@/components/dialogs/Index'
        ),
    Loading: () => import(
        '@/components/Loading'
        )
  }
}
</script>

<style scoped>

</style>
